import * as THREE from 'three'
import {
  adapterHeadNutSlotWidth,
  adapterHeadNutSlotPathInside,
  adapterHeadNutSlotPathOutside,
  adapterHeadBracketSlotPathInside,
  adapterHeadBracketSlotPathOutside,
  adapterInnerDistance,
  adapterHeadNutSlotDistance
} from 'src/constants/parameters'
import { v, stickPaths, mirrorVectorPath, rotateVectorPath } from './utils'
import sides, { Side, front, top, bottom, left, right, back } from 'src/constants/sides'

/* ADAPTER PATH MODULS */

const aInside = v(adapterHeadNutSlotPathInside)
const aOutside = v(adapterHeadNutSlotPathOutside)

const bInside = v(adapterHeadBracketSlotPathInside)
const bOutside = v(adapterHeadBracketSlotPathOutside)

const nutSlotPath = (inside: boolean = true) => (inside ? aInside : aOutside)
const bracketSlotPath = (inside: boolean = true) => (inside ? bInside : bOutside)

const cornerModule = (inside = true, side: 'left' | 'right' = 'left') => {
  const a = [
    new THREE.Vector2(2, 0),
    nutSlotPath(inside),
    new THREE.Vector2(2.5),
    bracketSlotPath(inside),
    new THREE.Vector2(5)
  ]
  return stickPaths([new THREE.Vector2(0, 0), ...(side === 'left' ? a : a.reverse())])
}

const middleModule = (inside = true) =>
  stickPaths([
    new THREE.Vector2(0, 0),
    new THREE.Vector2(5, 0),
    bracketSlotPath(inside),
    new THREE.Vector2(2.5),
    nutSlotPath(inside),
    new THREE.Vector2(2.5),
    bracketSlotPath(inside),
    new THREE.Vector2(5, 0)
  ])

const generateAdapterSidePath = (inside = true, amount = 5, distance = 3): THREE.Path =>
  stickPaths([
    cornerModule(inside),
    ...[...Array(amount)].reduce(
      (p, c) => [...p, new THREE.Vector2(distance, 0), middleModule(inside)],
      []
    ),
    new THREE.Vector2(distance, 0),
    cornerModule(inside, 'right')
  ])

const generateAdapterPlateHoles = (
  inside = true,
  { width, length }: { [key in 'width' | 'length']: number }
): THREE.Path[] => {
  return []
}

export const generateAdapterPlateShape = (
  inside = true,
  {
    width,
    length
  }: { [key in 'width' | 'length']: { value: number; amount: number; distance: number } }
) => {
  const widthSide = generateAdapterSidePath(inside, width.amount, width.distance)
  const lengthSide = generateAdapterSidePath(inside, length.amount, length.distance)

  const path = stickPaths([
    widthSide,
    mirrorVectorPath(rotateVectorPath(lengthSide, 90), 'y'),
    rotateVectorPath(widthSide, 180),
    mirrorVectorPath(rotateVectorPath(lengthSide, 270), 'y')
  ])
  const shape = new THREE.Shape(path.getPoints())
  // const holes = generateAdapterPlateHoles(inside, { width: width.value, length: length.value })
  // shape.holes.push(...holes)

  return shape
}
